import { render, staticRenderFns } from "./HistoryViewTimelineItem.vue?vue&type=template&id=0bc8a0ae&"
import script from "./HistoryViewTimelineItem.vue?vue&type=script&lang=js&"
export * from "./HistoryViewTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports